import { useEffect, useState } from 'react';

/**
 * useIsMobile — true when the viewport is narrower than `maxWidth` (default 720px).
 * Subscribes to media-query changes so toggling between landscape/portrait or
 * resizing the browser updates the value immediately.
 */
export default function useIsMobile(maxWidth = 720) {
  const query = `(max-width: ${maxWidth}px)`;

  const getInitial = () => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    try {
      return window.matchMedia(query).matches;
    } catch (_) {
      return false;
    }
  };

  const [isMobile, setIsMobile] = useState(getInitial);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const mql = window.matchMedia(query);
    const handler = (e) => setIsMobile(e.matches);
    // Safari < 14 only supports addListener/removeListener
    if (mql.addEventListener) {
      mql.addEventListener('change', handler);
    } else if (mql.addListener) {
      mql.addListener(handler);
    }
    // Sync once on mount in case it changed before subscription
    setIsMobile(mql.matches);
    return () => {
      if (mql.removeEventListener) {
        mql.removeEventListener('change', handler);
      } else if (mql.removeListener) {
        mql.removeListener(handler);
      }
    };
  }, [query]);

  return isMobile;
}
